import React from 'react'
import { useTranslation } from 'react-i18next'

import cn from 'classnames'

import { CustomButton, Modal } from 'src/components/ui'

import styles from './DeleteData.module.scss'
import { InfoItem } from './components'
import { useItems } from './hooks/useItems'

interface Props {
  className?: string
}

const DeleteDataPage: React.FC<Props> = ({ className }) => {
  const [isActiveModal, setIsActiveModal] = React.useState<boolean>(false)
  const { t } = useTranslation()
  const ITEMS = useItems(t)

  return (
    <div className={cn(styles.container, className)}>
      <h1 className={styles.title}>{t('delete_page.title')}</h1>

      <div className={styles.items}>
        {ITEMS.map((item) => (
          <InfoItem title={item} key={item} />
        ))}
      </div>

      <p className={styles.warning}>{t('delete_page.warning')}</p>

      <CustomButton className={styles.button} onClick={() => setIsActiveModal(true)} variant='contained' color='orange'>
        {t('delete_page.delete')}
      </CustomButton>

      {isActiveModal && (
        <Modal>
          <CustomButton onClick={() => setIsActiveModal(false)} variant='contained' color='violet'>
            Скасувати
          </CustomButton>
          <CustomButton onClick={() => {}} variant='contained' color='orange' opacity>
            Видалити назавжди
          </CustomButton>
        </Modal>
      )}
    </div>
  )
}

export default DeleteDataPage
